import React from 'react'
import NavBar from '../Component/NavBarFooter/NavBar'
import Banner from '../Component/QuickNewsPage/Banner'
import TabelData from '../Component/QuickNewsPage/TabelData'
import Footer from '../Component/NavBarFooter/Footer'
import CVReviewSection from '../Component/HomePage/CVReviewSection'

function QuickNewsPage() {
  return (
    <div>
        <NavBar/>
        <Banner/>
        <div className='mb-5'> 
        <TabelData/>

        </div>
        <Footer/>
    </div>
  )
}

export default QuickNewsPage